var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgWaveVertical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 1284,
    viewBox: "0 0 250 1284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_394_27)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_394_27",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -155,
    y: -898,
    width: 715,
    height: 2921
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246.221 2015.2C246.221 2015.2 106.148 1660.23 75.1529 1421.61C27.7643 1056.77 316.232 812.494 260.864 448.764C215.148 148.432 -60.2994 -97.3012 -116.657 -395.916C-161.856 -635.404 -132.601 -877.282 -132.601 -877.282",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M338.051 2003.18C338.051 2003.18 587.54 1439.35 556.545 1200.73C509.157 835.891 124.16 670.623 68.7931 306.893C23.0763 6.56143 377.283 -168.027 337.835 -469.231C304.688 -722.323 116.97 -896.943 116.97 -896.943",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M233.236 2016.91C233.236 2016.91 111.713 1651.99 80.718 1413.36C33.3294 1048.53 289.727 808.012 234.36 444.281C188.643 143.95 -56.8205 -98.3955 -112.373 -397.133C-156.998 -637.27 -138.075 -875.945 -138.075 -875.945",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.251 2018.61C220.251 2018.61 117.278 1643.74 86.2832 1405.12C38.8946 1040.28 263.223 803.529 207.855 439.799C162.138 139.467 -53.3415 -99.4904 -108.089 -398.352C-152.14 -639.136 -143.549 -874.608 -143.549 -874.608",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207.265 2020.31C207.265 2020.31 122.844 1635.5 91.8487 1396.87C44.4602 1032.04 236.718 799.047 181.351 435.317C135.634 134.985 -49.8621 -100.585 -103.804 -399.569C-147.282 -641.001 -149.022 -873.271 -149.022 -873.271",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M194.285 2022.01C194.285 2022.01 128.414 1627.25 97.4191 1388.63C50.0305 1023.79 210.219 794.564 154.852 430.833C109.135 130.502 -46.3779 -101.68 -99.5149 -400.788C-142.418 -642.867 -154.491 -871.934 -154.491 -871.934",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.136 2022.94C187.136 2022.94 139.815 1618.24 108.82 1379.62C61.4316 1014.78 189.551 789.317 134.183 425.587C88.4664 125.255 -37.063 -103.539 -89.3948 -402.77C-131.724 -645.497 -154.129 -871.361 -154.129 -871.361",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M193.668 2022.09C193.668 2022.09 164.899 1607.44 133.904 1368.82C86.515 1003.98 182.564 782.278 127.197 418.548C81.48 118.216 -14.0659 -107.189 -65.5924 -406.544C-107.348 -649.919 -140.085 -872.581 -140.085 -872.581",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M200.202 2021.23C200.202 2021.23 189.982 1596.64 158.987 1358.02C111.599 993.179 175.578 775.24 120.211 411.509C74.4941 111.178 8.93168 -110.84 -41.7896 -410.318C-82.9712 -654.341 -126.04 -873.8 -126.04 -873.8",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M206.734 2020.38C206.734 2020.38 215.065 1585.84 184.07 1347.22C136.682 982.379 168.591 768.201 113.224 404.471C67.5073 104.139 31.9283 -114.491 -17.9877 -414.092C-58.5954 -658.763 -111.996 -875.019 -111.996 -875.019",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M213.267 2019.52C213.267 2019.52 240.148 1575.04 209.153 1336.41C161.765 971.578 161.605 761.163 106.238 397.433C60.5209 97.1009 54.9255 -118.141 5.81465 -417.866C-34.2192 -663.185 -97.9522 -876.237 -97.9522 -876.237",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M219.803 2018.66C219.803 2018.66 265.236 1564.24 234.241 1325.61C186.852 960.776 154.622 754.123 99.2552 390.393C53.5384 90.0614 77.9264 -121.793 29.6208 -421.641C-9.83907 -667.607 -83.9041 -877.458 -83.9041 -877.458",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M226.336 2017.81C226.336 2017.81 290.319 1553.44 259.324 1314.81C211.935 949.976 147.636 747.085 92.2688 383.355C46.552 83.023 100.924 -125.443 53.4232 -425.414C14.5372 -672.029 -69.8599 -878.676 -69.8599 -878.676",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M232.868 2016.95C232.868 2016.95 315.402 1542.64 284.407 1304.01C237.018 939.175 140.649 740.046 85.2819 376.316C39.5651 75.984 123.92 -129.095 77.225 -429.189C38.9129 -676.451 -55.8162 -879.896 -55.8162 -879.896",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M239.401 2016.1C239.401 2016.1 340.486 1531.84 309.491 1293.21C262.102 928.374 133.663 733.008 78.296 369.277C32.5792 68.9456 146.918 -132.745 101.028 -432.963C63.2897 -680.873 -41.7715 -881.115 -41.7715 -881.115",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M245.934 2015.24C245.934 2015.24 365.569 1521.04 334.574 1282.41C287.185 917.573 126.677 725.969 71.3096 362.239C25.5929 61.9073 169.915 -136.396 124.83 -436.737C87.6659 -685.294 -27.7273 -882.334 -27.7273 -882.334",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M252.467 2014.39C252.467 2014.39 390.652 1510.23 359.657 1271.61C312.269 906.772 119.691 718.93 64.3232 355.2C18.6064 54.8683 192.912 -140.047 148.633 -440.511C112.042 -689.717 -13.6831 -883.553 -13.6831 -883.553",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M259.003 2013.53C259.003 2013.53 415.739 1499.43 384.744 1260.81C337.355 895.971 112.708 711.891 57.3403 348.161C11.6235 47.8294 215.913 -143.698 172.438 -444.286C136.422 -694.139 0.364531 -884.773 0.364531 -884.773",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M265.536 2012.67C265.536 2012.67 440.822 1488.63 409.827 1250.01C362.439 885.17 105.721 704.853 50.3539 341.123C4.63711 40.7908 238.91 -147.349 196.241 -448.06C160.798 -698.561 14.4088 -885.992 14.4088 -885.992",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M280.991 2010.65C280.991 2010.65 474.829 1476.66 443.834 1238.04C396.445 873.2 107.658 696.646 52.2906 332.915C6.57384 32.5836 270.83 -152.168 228.966 -453.002C194.097 -704.151 37.3761 -888.379 37.3761 -888.379",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M300.01 2008.16C300.01 2008.16 512.398 1464.23 481.403 1225.6C434.014 860.764 113.158 687.972 57.7903 324.242C12.0735 23.9097 306.313 -157.454 265.255 -458.412C230.96 -710.208 63.9064 -891.234 63.9064 -891.234",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M319.03 2005.67C319.03 2005.67 549.969 1451.79 518.974 1213.16C471.585 848.328 118.658 679.297 63.2911 315.567C17.5743 15.2356 341.797 -162.74 301.544 -463.821C267.823 -716.266 90.4377 -894.088 90.4377 -894.088",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_394_27)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -176.048,
    y: 1672.56,
    width: 2243,
    height: 885,
    transform: "rotate(-103.172 -176.048 1672.56)",
    fill: "url(#paint0_linear_394_27)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -176.048,
    y: 1672.56,
    width: 2243,
    height: 885,
    transform: "rotate(-103.172 -176.048 1672.56)",
    fill: "url(#paint1_linear_394_27)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_394_27",
    x1: 141.452,
    y1: 1813.06,
    x2: 1527.95,
    y2: 2115.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA1E81",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254421,
    stopColor: "#9F0C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774165,
    stopColor: "#F7468B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7468B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_394_27",
    x1: 517.452,
    y1: 2115.56,
    x2: 463.452,
    y2: 2232.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F03E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_394_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 1284,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgWaveVertical);
export default __webpack_public_path__ + "static/media/bg_wave_vertical.80a29f88a386c6bced9e572a1313cc0f.svg";
export { ForwardRef as ReactComponent };